import type { CSSProperties } from 'react';
import { colors } from '@tabbio/tokens';
import { novaFlatSvg } from './nova-flat-path';

/** Web twin of NovaFlatMark.tsx; same bytes from `nova-flat-path.ts`. */
export function NovaFlatMark({
  size = 18,
  color = colors.primary,
  style,
}: {
  size?: number;
  color?: string;
  style?: CSSProperties;
}) {
  return (
    <span
      aria-hidden
      style={{ display: 'block', flexShrink: 0, width: size, height: size, lineHeight: 0, ...style }}
      dangerouslySetInnerHTML={{ __html: novaFlatSvg({ color, size }) }}
    />
  );
}
